import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getApplicationStatusMessagesActiveListFetchSuccess,
    getApplicationStatusMessagesActiveListFetchFailure,
    updateApplicationStatusMessageFetchSuccess,
    updateApplicationStatusMessageFetchFailure,
    getApplicationStatusMessagesListFetchSuccess,
    getApplicationStatusMessagesListFetchFailure,
    getApplicationStatusMessagesListFetch as getApplicationStatusMessagesListFetchAction,
} from './reducer';
import { ApplicationStatusMessagesListResType } from 'src/types/applicationStatusMessagesList';
import translate from '@translate';
import { ApplicationStatusMessageType } from 'src/types/applicationStatusMessage';
import { ApplicationStatusMessageDetailResType } from 'src/types/applicationStatusMessageDetail';

const getApplicationStatusMessagesActiveListFetchRequest = async () => {
    const res = await api('get', 'api/secure/application-status-messages');
    return res.data.data;
};

function* getApplicationStatusMessagesActiveListFetch() {
    try {
        const response: ApplicationStatusMessagesListResType = yield call((): any =>
            getApplicationStatusMessagesActiveListFetchRequest()
        );
        yield put(getApplicationStatusMessagesActiveListFetchSuccess(response));
    } catch (error) {
        yield put(getApplicationStatusMessagesActiveListFetchFailure({ error }));
    }
}

export function* getApplicationStatusMessagesActiveListFetchWatch() {
    yield takeEvery(
        'applicationStatusMessagesList/getApplicationStatusMessagesActiveListFetch',
        getApplicationStatusMessagesActiveListFetch
    );
}

const getApplicationStatusMessagesListFetchRequest = async () => {
    const res = await api('get', 'api/secure/application-status-messages/all');
    return res.data.data;
};

function* getApplicationStatusMessagesListFetch() {
    try {
        const response: ApplicationStatusMessagesListResType = yield call((): any =>
            getApplicationStatusMessagesListFetchRequest()
        );
        yield put(getApplicationStatusMessagesListFetchSuccess(response));
    } catch (error) {
        yield put(getApplicationStatusMessagesListFetchFailure({ error }));
    }
}

export function* getApplicationStatusMessagesListFetchWatch() {
    yield takeEvery(
        'applicationStatusMessagesList/getApplicationStatusMessagesListFetch',
        getApplicationStatusMessagesListFetch
    );
}

const updateApplicationStatusMessageFetchRequest = async (params: {
    idApplicationStatusMessage: string;
    data: ApplicationStatusMessageType;
}) => {
    const res = await api(
        'put',
        `api/secure/application-status-messages/${params.idApplicationStatusMessage}`,
        params.data
    );
    return res.data.data;
};

function* updateApplicationStatusMessageFetch(action: {
    type: string;
    payload: { idApplicationStatusMessage: string; data: ApplicationStatusMessageType };
}) {
    try {
        const response: ApplicationStatusMessageDetailResType = yield call((): any =>
            updateApplicationStatusMessageFetchRequest(action.payload)
        );
        yield put(
            updateApplicationStatusMessageFetchSuccess({
                ...response,
                messageSuccess: {
                    title: translate('applicationStatusMessages.message.applicationStatusMessageUpdate'),
                },
            })
        );
        yield put(getApplicationStatusMessagesListFetchAction());
    } catch (error) {
        yield put(updateApplicationStatusMessageFetchFailure({ error }));
    }
}

export function* updateApplicationStatusMessageFetchWatch() {
    yield takeEvery(
        'applicationStatusMessagesList/updateApplicationStatusMessageFetch',
        updateApplicationStatusMessageFetch
    );
}
